import Vue from "vue";
import "./../node_modules/normalize.css/normalize.css";
import "element-ui/lib/theme-chalk/display.css";
import "./assets/app.scss";

import lineClamp from "vue-line-clamp";
Vue.use(lineClamp);

import VueProgressBar from "vue-progressbar";
Vue.use(VueProgressBar, {
	color: "#3d85ff",
	failedColor: "red",
	thickness: "5px"
});
